export default __webpack_public_path__ + "static/media/plus.dd12edb9.svg";